/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Back_Offer_PageInputs */

const en_back_offer_page = /** @type {(inputs: Back_Offer_PageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Back to Offer`)
};

const ar_back_offer_page = /** @type {(inputs: Back_Offer_PageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`العودة إلى العرض`)
};

const de_back_offer_page = /** @type {(inputs: Back_Offer_PageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zurück zu Angebot`)
};

const es_back_offer_page = /** @type {(inputs: Back_Offer_PageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Volver a la oferta`)
};

const fr_back_offer_page = /** @type {(inputs: Back_Offer_PageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Revenir à l'offre`)
};

const it_back_offer_page = /** @type {(inputs: Back_Offer_PageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Torna all'offerta`)
};

const ja_back_offer_page = /** @type {(inputs: Back_Offer_PageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`オファーに戻る`)
};

const ko_back_offer_page = /** @type {(inputs: Back_Offer_PageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`혜택 다시 보기`)
};

const pt_br_back_offer_page = /** @type {(inputs: Back_Offer_PageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Retornar à oferta`)
};

const ru_back_offer_page = /** @type {(inputs: Back_Offer_PageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Вернуться к предложению`)
};

const th_back_offer_page = /** @type {(inputs: Back_Offer_PageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`กลับไปยังข้อเสนอ`)
};

const tr_back_offer_page = /** @type {(inputs: Back_Offer_PageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Teklife Geri Dön`)
};

const zh_cn_back_offer_page = /** @type {(inputs: Back_Offer_PageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`返回优惠页`)
};

const zh_tw_back_offer_page = /** @type {(inputs: Back_Offer_PageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`返回優惠頁`)
};

/**
* | output |
* | --- |
* | "Back to Offer" |
*
* @param {Back_Offer_PageInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const back_offer_page = /** @type {((inputs?: Back_Offer_PageInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Back_Offer_PageInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_back_offer_page(inputs)
	if (locale === "ar") return ar_back_offer_page(inputs)
	if (locale === "de") return de_back_offer_page(inputs)
	if (locale === "es") return es_back_offer_page(inputs)
	if (locale === "fr") return fr_back_offer_page(inputs)
	if (locale === "it") return it_back_offer_page(inputs)
	if (locale === "ja") return ja_back_offer_page(inputs)
	if (locale === "ko") return ko_back_offer_page(inputs)
	if (locale === "pt_br") return pt_br_back_offer_page(inputs)
	if (locale === "ru") return ru_back_offer_page(inputs)
	if (locale === "th") return th_back_offer_page(inputs)
	if (locale === "tr") return tr_back_offer_page(inputs)
	if (locale === "zh_cn") return zh_cn_back_offer_page(inputs)
	return zh_tw_back_offer_page(inputs)
});